let videosSwiper = new Swiper(".video-carousel__swiper", {
    slidesPerView: 'auto',
    initialSlide:1,
    centeredSlides: true,
    spaceBetween: 33,
    navigation: {
        nextEl: ".video-carousel-next",
        prevEl: ".video-carousel-prev",
    },
 
    on: {
        click: function (event) {
            if (!this.clickedSlide?.classList.contains('swiper-slide-active')) {
                this.slideToLoop(this.clickedSlide?.getAttribute('data-info'));
                
            }
        },
    },
});

